// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cpj-singlePageWrapper{line-height:23px}.site-map-block{margin-bottom:32px}h3{font-size:17px;color:#707070;font-weight:700}.cpj-singlePageWrapper a{display:list-item;list-style-type:disc;list-style-position:inside;color:#2b59c3;font-size:14px;line-height:32px}", ""]);
// Exports
module.exports = exports;
